import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import '../styles/pages/terms_privacy.scss'

const Privacy = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          privacy {
            name
            heading
            subheading
            collection
         
            thirdcolle
            information
          }
        }
      }
    }
  `)

  const { name, heading, subheading, collection,thirdcolle, information } =
    data.site.siteMetadata.privacy
  return (
    <>
      <h1 className="legal-heading">{name}</h1>
      <div className="container">
        <div className="privacy">
          <h3 className="privacy__heading">Activity Information</h3>
          <p>{heading}</p>

          <h4 className="privacy__subheading">Device and Usage Information:</h4>
          <p>{subheading}</p>

          <h4 className="privacy__subheading">
            Information Collected by Cookies:
          </h4>
          <p>{collection}</p><br />

        
          <p>{thirdcolle}</p>

          
          
          <h4 className="privacy__subheading">Use of Information</h4>
          <p>{information}</p>
          <br />
          <p>If you have any queries, please do not hesitate to contact us.</p>
        </div>
      </div>
    </>
  )
}

export default Privacy
